import * as Sentry from "@sentry/react"
import { IContactValues } from "../../contact"
import { IFormType, IHSField, IHSPayload } from "../types"
import { getCookie } from "../utils"
import { FORM_GUID_MAP, OBJECT_TYPE_ID_MAP, PAGE_NAME_MAP } from "./constants"

const PORTAL_ID = 20462440
const COOKIE_NAME = "hubspotutk"

const getContactFields = (formValues: IContactValues) => {
  const fields = []
  for (const [key, value] of Object.entries(formValues)) {
    fields.push({
      objectTypeId: OBJECT_TYPE_ID_MAP["contact"],
      name: key,
      value: value,
    })
  }

  return fields
}

const getBasePayload = (formType: IFormType) => {
  const payload: IHSPayload = {
    fields: [],
    context: {
      pageUri: window.location.href,
      pageName: PAGE_NAME_MAP[formType],
    },
  }

  const cookie = getCookie(COOKIE_NAME)
  if (cookie !== undefined) {
    payload.context["hutk"] = cookie
  }

  return payload
}

const sendForm = async (
  formType: IFormType,
  contactValues: IContactValues,
  extraFields: IHSField[]
) => {
  const payload = getBasePayload(formType)
  const contactFields = getContactFields(contactValues)
  payload.fields = [...contactFields, ...extraFields]

  try {
    const endpoint = process.env.REACT_APP_HUBSPOT_ENDPOINT
    if (!endpoint) throw new Error("HubSpot endpoint not defined")

    const response = await window.fetch(
      endpoint + "/" + PORTAL_ID + "/" + FORM_GUID_MAP[formType],
      {
        method: "POST",
        headers: {
          "content-type": "application/json",
        },
        body: JSON.stringify(payload),
      }
    )
    if (!response.ok) {
      const text = await response.text()
      Sentry.captureException(
        `failed to send form to HubSpot with ${response.status}`,
        // NOTE: ideally we want to send this as an object, but as of June 2023,
        // nested objects are shown like [Object] on Sentry UI
        // Javascript SDK has a workaround but no corresponding helper found in React
        // https://github.com/getsentry/sentry-javascript/issues/1964
        { extra: { response_text: text, payload: JSON.stringify(payload) } }
      )
      return false
    }
    return true
  } catch (error) {
    Sentry.captureException(error, {
      extra: { payload: JSON.stringify(payload) },
    })
    return false
  }
}

export { sendForm }
